import axios from 'axios'
import router from "../router";
// import qs from 'qs'
// import {Toast} from 'vant'

// let loading = null;

axios.interceptors.request.use(config=>{
    config.headers['Content-Type'] = 'application/json';
    if(config.url.indexOf('https://')==-1){
        if(window.location.host == '192.168.1.169:8080'){
            // config.url = config.url;
            // config.url = 'https://dudao.tianwangwatch.cn' + config.url;
            config.url = 'https://dudao.tianwangwatch.cn' + config.url;
            // config.url = '' + config.url;
        }else if(window.location.host == 'localhost:8080'){
            config.url = '' + config.url;
        }else if(window.location.host == 'http://47.92.121.124:9082'){
            // console.log('kkkk')
            // config.url = 'https://dudao.tianwangwatch.cn' + config.url;
            config.url = 'https://dudao.tianwangwatch.cn' + config.url;
        } else if(window.location.host == 'http//dudao.tianwangwatch.cn'){
            // config.url = 'https://dudao.tianwangwatch.cn' + config.url;
            config.url = 'https://dudao.tianwangwatch.cn' + config.url;
        } else {
            config.url = 'https://dudao.tianwangwatch.cn' + config.url;
            // config.url = 'https://dudao.tianwangwatch.cn' + config.url;
        }
    }
    // loading = Toast.loading({
    //     mask: true,
    //     forbidClick: true,
    //     message: '正在加载'
    // });

    return config;
}, error=>{
    // console.error('加载超时');
    // loading.clear();
    return Promise.reject(error);
});

//添加响应拦截器
axios.interceptors.response.use(function(response){
    // console.log('response',response)
    if(response.data.code != 500 || response.data.code != 501){
        return response;
    } else if(response.data.code == 501){
        console.log('登录失效,请重新登录');
        if(response.data.code == 501) {
            window.localStorage.removeItem('_t');
            window.location.href = 'http://dudao.tianwangwatch.cn';
        }
        return Promise.reject(error);
        // router.push({
        //     name: 'error',
        //     query: {
        //         error: '501'
        //     }
        // })
    } else if(response.data.code == 500){
        return Promise.reject(error);
        // router.push({
        //     name: 'error',
        //     query: {
        //         error: '500'
        //     }
        // })
    }
},function(error){
    console.log('error',error);
    return Promise.reject(error);
});

export default axios



// WEBPACK FOOTER //
// ./src/utils/axios.js